import type { ClientSideValidationErrors } from '@/company-portal/add-file/add-file-form-errors.types';
import type { AddFileValidateRequest } from '@/company-portal/add-file/add-file.types';
import { ClientValidationErrorKeys } from '@/components/Views/Company/File/Client/client-info-form.types';

export const ROLE_ERROR_MESSAGE = 'Select a role';

export const useAddFileValidation = () => {
    const validateClientRoles = (request: AddFileValidateRequest): ClientSideValidationErrors => {
        if (!request.clients?.length) {
            return {};
        }
        const errors: ClientSideValidationErrors = {};
        for (const client of request.clients) {
            if (!client.role) {
                errors[`${ClientValidationErrorKeys.ROLE}.${client.id}`] = [ROLE_ERROR_MESSAGE];
            }
        }
        return errors;
    };

    const validateAddFileRequest = (
        request: AddFileValidateRequest,
    ): { hasError: boolean; errors: ClientSideValidationErrors } => {
        const errors = validateClientRoles(request);
        const hasError = Object.keys(errors).length > 0;
        return {
            hasError,
            errors,
        };
    };

    return { validateAddFileRequest };
};
